<script setup lang="ts">
import BaseMessage from '@/overlays/BaseMessage.vue';

interface Props {
  description?: string;
}

const props = defineProps<Props>();

defineEmits<{ close: [] }>();
</script>

<template>
  <BaseMessage
    variant="error"
    :title="$t('global.somethingWentWrong')"
    :description="description"
    :autoClose="false"
    @close="$emit('close')"
  />
</template>
